import { useEffect, useState } from "react";
import {
  getAccommodation,
  getAllAccommodations,
  // getOneAccommodationShort,
} from "../../services/AccommodationService";
import "./EventAccommodation.scss";
import { Button, Form, Input, Select, Space } from "antd";
import { DeleteOutlined, MinusCircleOutlined } from "@ant-design/icons";
import RoomTypeInEvent from "./RoomTypeInEvent";
import { AxiosError, AxiosResponse } from "axios";
import {
  ShortOneAccommodation,
  UpdateAccommodationDto,
} from "../../models/Accommodation";
import CustomButton from "../AccommodationData/CustomButton/CustomButton";
import Bin from "../../assets/bin.png";

const EventAccommodation = (props: any) => {
  const [id, setId] = useState("");
  const [oneAccommodation, setOneAccommodation] =
    useState<ShortOneAccommodation>();
  const accommodationFields = props.form.getFieldValue("accommodations");

  const Option = Select.Option;

  useEffect(() => {
    if (id === "") return;
    getAccommodation(id)
      .then((response: AxiosResponse) => {
        let data = response.data.result;

        let oneAccommodation = {
          id: data.id,
          name: data.name,
          address: data.address,
          totalNumberOfRooms: data.totalNumberOfRooms,
          roomType: data.roomType,
        };

        setOneAccommodation(oneAccommodation);

        const fields = props.form.getFieldsValue();
        const { accommodations } = fields;
        Object.assign(accommodations[props.name], {
          ...oneAccommodation,
        });
      })
      .catch((err: AxiosError) => console.log(err));
  }, [id]);

  const handleDropdown = (chooseOneAccommodation: string) => {
    setId(chooseOneAccommodation);
  };

  const chooseOneAccommodation = (accommodation: ShortOneAccommodation) => {
    setOneAccommodation(accommodation);
  };

  return (
    <div className="event-accommodation">
      <div className="innter-container">
        <Form.Item
          name={[props.name, "name"]}
          label="Smeštaj:"
          rules={[
            {
              required: true,
              message: "Potrebno je izabrati smeštaj!",
            },
          ]}
        >
          <Select onChange={handleDropdown} placeholder="Izaberite smeštaj">
            {props.allAccommodationOption.map(
              (oneAccommodation: any, i: number) => (
                <Option
                  disabled={props?.accommodationFields?.find(
                    (data: UpdateAccommodationDto) => {
                      return data?.id === oneAccommodation.id;
                    }
                  )}
                  key={oneAccommodation.id}
                  value={oneAccommodation.id}
                >
                  {oneAccommodation.value}
                </Option>
              )
            )}
          </Select>
        </Form.Item>
        <Form.Item
          //{...props.restField}
          name={[props.name, "address"]}
          label="Adresa smeštaja:"
        >
          <Input className="input-label" disabled />
        </Form.Item>
        <div className="total-room">
          <Form.Item
            //{...props.restField}
            className="total-room-field"
            name={[props.name, "totalNumberOfRooms"]}
            label="Ukupno soba:"
          >
            <Input className="input-label" disabled />
          </Form.Item>
          <div className="footer-agenda">
            <span className="btn">
              <DeleteOutlined onClick={() => props.remove(props.name)} />
            </span>
          </div>
        </div>
        <Form.List name={[props.name, "roomTypes"]}>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restFieldsRoomType }) => (
                <Space key={key} className="list-of-data" align="baseline">
                  {/* <MinusCircleOutlined onClick={() => remove(name)} /> */}
                  <RoomTypeInEvent
                    fields={fields}
                    form={props.form}
                    oneAccommodation={oneAccommodation}
                    name={name}
                    restFieldsRoomType={{ ...restFieldsRoomType }}
                    restFieldAccommodation={props.restField}
                    nameAccommodations={props.name}
                    remove={remove}
                    selectedRange={props.selectedRange}
                  />
                </Space>
              ))}
              {accommodationFields?.map(
                (accommodation: ShortOneAccommodation, i: number) => {
                  if (i === props.name) {
                    if (
                      accommodation?.roomTypes == undefined ||
                      accommodation?.roomTypes?.length == undefined ||
                      accommodation?.roomTypes?.length <
                        accommodation?.roomType?.length
                    ) {
                      return (
                        <Form.Item className="add-new-btn">
                          <CustomButton
                            // danger={false}
                            // htmlType={""}
                            // type=""
                            function={() => {
                              add();
                              chooseOneAccommodation(accommodation);
                            }}
                            text={"Dodajte sobu"}
                          />
                        </Form.Item>
                      );
                    }
                  }
                }
              )}
            </>
          )}
        </Form.List>
      </div>
    </div>
  );
};

export default EventAccommodation;
